// removed by extract-text-webpack-plugin
module.exports = {"Button":"_2pL_iyXYFib01jKMV2FU6h","Button--small":"nAXNFFFr-TwLyW3N9PAgc","Button--lite":"_2FtdNW0hoWEmyp5rZL3DBv","Button--fat":"_3ULtLoEgJTgN-Su4bj_FAZ","Button--fullWidth":"_3iub0-S0JJNdzd9LhkZ00Z","Button--primary":"_12l8aXpMTB_6KhqYnxSAHp","Button--secondary":"_3qYlY_nDMAWtm5E2CuvXua"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.scss
// module id = 2569
// module chunks = 0